import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'next-themes';
import App from './App';
import ErrorBoundary from './components/common/ErrorBoundary';
import { initSentry } from './lib/sentry';
import './assets/styles/global.css';
import './i18n';
import archiPlanIcon from './assets/ArchiPlan_3_icone_seule.png';

// Initialiser Sentry avant tout rendu React
initSentry();

const ensureFavicon = () => {
  if (typeof document === 'undefined') return;
  const existing = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  const link = existing ?? document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/png';
  link.href = archiPlanIcon;
  if (!existing) {
    document.head.appendChild(link);
  }
};

ensureFavicon();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>,
);
